import React from 'react';
import { Outlet } from 'react-router-dom';
import { Card, CardHeader, CardTitle } from '../../../../components/ui/card'; // 

const CouponManagement = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Coupon Management</CardTitle>
      </CardHeader>
      <div className="p-6">
        <Outlet />
      </div>
    </Card>
  );
};

export default CouponManagement;